(() => {
  const galleries = document.querySelectorAll('[data-pawtala-gallery]');

  galleries.forEach((gallery) => {
    if (gallery.dataset.galleryReady === 'true') return;

    const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    const thumbnails = Array.from(gallery.querySelectorAll('[data-gallery-thumbnail]'));
    const previous = gallery.querySelector('[data-gallery-previous]');
    const next = gallery.querySelector('[data-gallery-next]');
    const counter = gallery.querySelector('[data-gallery-counter]');
    let activeIndex = 0;

    if (slides.length < 2) {
      previous?.setAttribute('hidden', '');
      next?.setAttribute('hidden', '');
      counter?.setAttribute('hidden', '');
    }

    const showSlide = (requestedIndex, moveFocus = false) => {
      activeIndex = (requestedIndex + slides.length) % slides.length;

      slides.forEach((slide, index) => {
        const isActive = index === activeIndex;
        slide.hidden = !isActive;
        slide.classList.toggle('is-active', isActive);
      });

      thumbnails.forEach((thumbnail, index) => {
        const isActive = index === activeIndex;
        thumbnail.classList.toggle('is-active', isActive);
        thumbnail.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      thumbnails[activeIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      if (counter) counter.textContent = `${activeIndex + 1} / ${slides.length}`;
      if (moveFocus) gallery.querySelector('.pawtala-product-gallery__stage')?.focus({ preventScroll: true });
    };

    previous?.addEventListener('click', () => showSlide(activeIndex - 1));
    next?.addEventListener('click', () => showSlide(activeIndex + 1));
    thumbnails.forEach((thumbnail, index) => thumbnail.addEventListener('click', () => showSlide(index)));

    gallery.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') showSlide(activeIndex - 1);
      if (event.key === 'ArrowRight') showSlide(activeIndex + 1);
    });

    let touchStartX = 0;
    gallery.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX || 0;
    }, { passive: true });
    gallery.addEventListener('touchend', (event) => {
      const distance = (event.changedTouches[0]?.clientX || 0) - touchStartX;
      if (Math.abs(distance) < 45) return;
      showSlide(activeIndex + (distance < 0 ? 1 : -1));
    }, { passive: true });

    gallery.dataset.galleryReady = 'true';
    showSlide(0);
  });
})();
